<script>
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();

export let items;
export let activeItem;
</script>

<div class="tabs">
<ul>
    {#each items as item}
        <li on:click={() => dispatch('tabChange', item)} on:keydown>
           <div class:active={item === activeItem}>{item}</div>
        </li>
    {/each}
</ul>
</div>

<style>

.tabs {
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 40px;
}
ul {
    list-style: none;
    display: flex;
    gap: 20px;
    padding: 0;
    margin: 0;
    justify-content: center;
    color: #555;
    cursor: pointer;
}
.active {
    color: #d91b42;
    border-bottom: 2px solid #d91b42;
    padding-bottom: 4px;
}
</style>